import { render, staticRenderFns } from "./privacypolicysactin.vue?vue&type=template&id=5346e748&scoped=true&"
import script from "./privacypolicysactin.vue?vue&type=script&lang=js&"
export * from "./privacypolicysactin.vue?vue&type=script&lang=js&"
import style0 from "./privacypolicysactin.vue?vue&type=style&index=0&id=5346e748&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5346e748",
  null
  
)

export default component.exports